import { useQuery } from '@tanstack/react-query'
import type { QueryKey } from '@tanstack/react-query'

/**
 * This hook is used to subscribe to a query's data changes without fetching it.
 */
export const useObserveQuery = <TData>(queryKey: QueryKey) => {
  return useQuery<TData>(queryKey, { enabled: false })
}
